import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import createDecorator from 'final-form-calculate';
import { Typography } from '@material-ui/core';
import OrganisationDetails from './OrganisationDetails';
import Attendees from './Attendees';
import PaymentDetails from './PaymentDetails';
import React from 'react';
import memoize from '../utilities/memoize';


const calculateTotal = memoize(async (member, attendees) => {
  if (attendees) {
    const url = window._NZACA_EVENTS_PRICE_URL;
    const eventID = window._NZACA_EVENTS_EVENTID;
    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ eventID, member, attendees }),
    });
    const price = await response.json();
    return price.price * attendees;
  }
});

const countAttendees = attendees => attendees.filter(a => a && a.Name).length;

const calculator = createDecorator({
  field: /NZACAMember|Attendee/,
  updates: {
    total: (ignoredValue, allValues) => calculateTotal(allValues.NZACAMember,
      countAttendees(allValues.Attendees)),
  },
});

const Registration = ({onSubmit}) => (
  <Form
    onSubmit={onSubmit}
    mutators={{
      ...arrayMutators,
    }}
    decorators={[calculator]}
    initialValues={{ Attendees: [undefined] }}
    render={({ handleSubmit, form: { mutators: { push } }, pristine, invalid, submitting, values }) => (
      <form onSubmit={handleSubmit}>
        <Typography variant="h4">Register now!</Typography>
        <OrganisationDetails/>
        <Attendees push={push}/>
        <PaymentDetails
          invalid={invalid}
          pristine={pristine}
          submitting={submitting}
          attendeeCount={countAttendees(values.Attendees)}
          total={values.total}
        />
      </form>
    )}
  />
);

export default Registration;
